import PropTypes from 'prop-types';
import { IconContext } from 'react-icons';
import { FiX } from 'react-icons/fi';

const AddPostHeader = ({ onDismiss = () => {}, title = '' }) => {
  return (
    <div className="flex items-center justify-between px-4 py-2">
      <button type="button" onClick={onDismiss} className="text-on-surface">
        <IconContext.Provider
          // eslint-disable-next-line react/jsx-no-constructed-context-values
          value={{
            size: '24px',
            style: {
              color: 'inherit',
            },
          }}
        >
          <FiX />
        </IconContext.Provider>
      </button>
      {title ? (
        <div className="flex-1 px-3 text-center text-lg font-semibold text-on-surface">
          {title}
        </div>
      ) : (
        <div className="flex-1" />
      )}
      <div className="w-6" />
    </div>
  );
};

AddPostHeader.propTypes = {
  onDismiss: PropTypes.func,
  title: PropTypes.string,
};

export default AddPostHeader;
